// #region Imports
import { createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState } from "_shared/_stores/redux-store";
import { bookmarksApi } from "marketplace/bookmarks/_api/bookmark-api";
import { BookmarkedCompanyJSON } from "marketplace/bookmarks/company-bookmarks/_schema/bookmarked-company-schema";
import { BookmarkedIndividualJSON } from "marketplace/bookmarks/individual-bookmarks/_schema/bookmarked-individual-schema";
import { BookmarkedTeamJSON } from "marketplace/bookmarks/team-bookmarks/_schema/bookmarked-team-schema";
// #endregion

// #region Store State Type
export type BookmarksState = {
  companyBookmarks?: BookmarkedCompanyJSON[];
  individualBookmarks?: BookmarkedIndividualJSON[];
  teamBookmarks?: BookmarkedTeamJSON[];
};
// #endregion

// #region Initial State
const initialState: BookmarksState = {
  companyBookmarks: undefined,
  individualBookmarks: undefined,
  teamBookmarks: undefined,
};
// #endregion

// #region Slice
export const bookmarksSlice = createSlice({
  name: "bookmarks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // #region RTK Query matchers
    builder.addMatcher(bookmarksApi.endpoints.getAllCompanyBookmarks.matchFulfilled, (state, action) => {
      state.companyBookmarks = action.payload;
    });

    builder.addMatcher(bookmarksApi.endpoints.getAllIndividualBookmarks.matchFulfilled, (state, action) => {
      state.individualBookmarks = action.payload;
    });

    builder.addMatcher(bookmarksApi.endpoints.getAllTeamBookmarks.matchFulfilled, (state, action) => {
      state.teamBookmarks = action.payload;
    });
    // #endregion
  },
});
// #endregion

// #region Exports

// #region Selectors

// companyBookmarks
const selectCompanyBookmarks = createSelector(
  [(state: RootState) => state.bookmarks.companyBookmarks],
  (entries) => entries ?? []
);
export const getCompanyBookmarks = () => (state: RootState) => selectCompanyBookmarks(state);

export const getIsLoadingCompanyBookmarks = () => (_state: RootState) => false;
export const getErrorLoadingCompanyBookmarks = () => (_state: RootState) => null;

// individualBookmarks
const selectIndividualBookmarks = createSelector(
  [(state: RootState) => state.bookmarks.individualBookmarks],
  (entries) => entries ?? []
);
export const getIndividualBookmarks = () => (state: RootState) => selectIndividualBookmarks(state);

export const getIsLoadingIndividualBookmarks = () => (_state: RootState) => false;
export const getErrorLoadingIndividualBookmarks = () => (_state: RootState) => null;

// teamBookmarks
const selectTeamBookmarks = createSelector(
  [(state: RootState) => state.bookmarks.teamBookmarks],
  (entries) => entries ?? []
);
export const getTeamBookmarks = () => (state: RootState) => selectTeamBookmarks(state);

export const getIsLoadingTeamBookmarks = () => (_state: RootState) => false;
export const getErrorLoadingTeamBookmarks = () => (_state: RootState) => null;

// #endregion
// #endregion
